"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntersectionManager = void 0;
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const viewer_shared_types_1 = require("@shapediver/viewer.shared.types");
const viewer_rendering_engine_intersection_engine_1 = require("@shapediver/viewer.rendering-engine.intersection-engine");
const InteractionData_1 = require("./InteractionData");
const viewer_shared_node_tree_1 = require("@shapediver/viewer.shared.node-tree");
class IntersectionManager {
    // #endregion Properties (5)
    // #region Constructors (1)
    constructor() {
        // #region Properties (5)
        this._eventEngine = viewer_shared_services_1.EventEngine.instance;
        this._intersectionEngine = viewer_rendering_engine_intersection_engine_1.IntersectionEngine.instance;
        this._tree = viewer_shared_node_tree_1.Tree.instance;
        this._intersectNodes = [];
        this.gatherNodes();
        this._eventEngine.addListener(viewer_shared_services_1.EVENTTYPE.VIEWPORT.VIEWPORT_UPDATED, () => {
            this.gatherNodes();
        });
    }
    // #endregion Constructors (1)
    // #region Public Static Getters And Setters (1)
    static get instance() {
        return this._instance || (this._instance = new this());
    }
    // #endregion Public Static Getters And Setters (1)
    // #region Public Methods (1)
    intersect(ray, viewportId, filterCriteria = []) {
        let intersections = [];
        // intersect all nodes
        this._intersectNodes.forEach(i => {
            const currentIntersection = this._intersectionEngine.intersectNode(ray, i.node, i.geometryData, viewportId, filterCriteria);
            if (currentIntersection)
                intersections = intersections.concat(currentIntersection);
        });
        // sort
        intersections.sort((a, b) => a.distance - b.distance);
        return intersections;
    }
    // #endregion Public Methods (1)
    // #region Private Methods (1)
    gatherNodes() {
        this._intersectNodes = [];
        this._tree.root.traverse(node => {
            if (node.visible === false)
                return;
            for (let i = 0; i < node.data.length; i++) {
                if (node.data[i] instanceof InteractionData_1.InteractionData) {
                    const geometryData = {};
                    node.traverseData(d => {
                        if (d instanceof viewer_shared_types_1.GeometryData) {
                            geometryData[`${d.id}_${d.version}`] = d;
                        }
                    });
                    this._intersectNodes.push({ node: node, geometryData: geometryData });
                }
            }
        });
    }
}
exports.IntersectionManager = IntersectionManager;
//# sourceMappingURL=IntersectionManager.js.map